import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { FilterGroup } from '../../models/historico-de-vendas-filter.models';
import { HistoricoDeVendasFilterService } from '../historico-de-vendas-filter/historico-de-vendas-filter.service';
import { SendCheckboxStatusDataService } from '@brunsker/libs/portal-do-vendedor/ui/checkbox-status';

@Injectable({
  providedIn: 'root',
})
export class HistoricoDeVendasFilterGroupService {
  filterGroupData$!: Observable<FilterGroup>;

  constructor(
    private readonly checkboxStatus: SendCheckboxStatusDataService,
    private readonly historicoDeVendasFilter: HistoricoDeVendasFilterService
  ) {}


  getFilters() {
    const parameters = {
      dataInicial: this.historicoDeVendasFilter.courrent_filter.dataInicial,
      dataFinal: this.historicoDeVendasFilter.courrent_filter.dataFinal,
      orcamento: this.historicoDeVendasFilter.courrent_filter.orcamento,
      pedido: this.historicoDeVendasFilter.courrent_filter.pedido,
      filial: this.historicoDeVendasFilter.courrent_filter.filial,
      cliente: this.historicoDeVendasFilter.courrent_filter.cliente,
      vendedor: this.historicoDeVendasFilter.courrent_filter.vendedor,
    }

    this.historicoDeVendasFilter.historicoDeVendasFilter$$.next(parameters);

    this.filterGroupData$ = combineLatest([
      this.checkboxStatus.checkboxData$$,
      this.historicoDeVendasFilter.historicoDeVendasFilter$$,
    ]).pipe(
      map(([checkboxData, historicoDeVendasFilter]) => {

        return {
          dataInicial: historicoDeVendasFilter.dataInicial,
          dataFinal: historicoDeVendasFilter.dataFinal,
          orcamento: historicoDeVendasFilter.orcamento,
          pedido: historicoDeVendasFilter.pedido,
          filial: historicoDeVendasFilter.filial,
          cliente: historicoDeVendasFilter.cliente,
          vendedor: historicoDeVendasFilter.vendedor,
          checkboxData: checkboxData,
        };
      })
    );

    return this.filterGroupData$;
  }
}
